export default "__VITE_ASSET__nY8HUF4f__"